import React from 'react'
import './Steps.css'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

const Steps = (props) => {

  return <div className="steps-container">
    {
      props.items.map((item, index) => {
        return <div key={index} className="steps-inner-container">
          <div className={`steps-item ${props.currentIndex < index + 1 ? (props.currentIndex === index ? 'focused' : 'unchecked') : 'checked'}`}>

            <div className={`steps-number`}>{props.currentIndex < index + 1 ? index + 1 : <FontAwesomeIcon icon={faCheck} size={"sm"} color="white" />}</div></div>
          {index !== props.items.length - 1 ? <hr className="steps-line" /> : null}
        </div>
      })
    }
  </div>
}

export default Steps